export enum Input {
  // Details
  FirstName = 'first_name',
  LastName = 'last_name',
  Email = 'email',
  Phone = 'phone',
  InternalNotes = 'internal_notes',

  // Pets
  Pets = 'pets',
  PetName = 'pet_name',
  PetGender = 'pet_gender',
  PetBreed = 'pet_breed',
  PetBirthDate = 'pet_birth_date',
  PetSizeCategory = 'pet_size_category',
  PetCoatType = 'pet_coat_type',
  PetInternalNotes = 'pet_internal_notes',
}
